import actionCreatorFactory from "typescript-fsa";
import { OpenAlertBanner } from "./reducer";

const create = actionCreatorFactory("alertBanner");

export const showAlertBanner = create<OpenAlertBanner>("SHOW_ALERT_BANNER");
export const resetAlertBanner = create("RESET_ALERT_BANNER");



// WEBPACK FOOTER //
// ./src/shared/alertBanner/actions.ts